import React, { useState, useRef, useEffect } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { FaStar, FaExclamationCircle, FaLightbulb } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import BackMethods from "../../back_component/BackMethods";
import { can, PERMISSIONS } from "../../auth/permissions";

export default function GenerateUIDPage() {
    const { backEnd_request } = BackMethods();
    const navigate = useNavigate();
    const location = useLocation();

    const canCreate = can(PERMISSIONS.GENERATE_UID_CREATE);
    const canExportPdf = can(PERMISSIONS.GENERATE_UID_EXPORT_PDF);

    const [count, setCount] = useState(2);
    const [generatedData, setGeneratedData] = useState([]);
    const [isExporting, setIsExporting] = useState(false);
    const [loading, setLoading] = useState(false);

    const exportRef = useRef();
    const baseUrl = "https://custpro.org/";

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const passedUid = params.get("uid") || location.state?.uid;
        const passedId = params.get("id") || location.state?.id;

        if (passedUid) {
            setGeneratedData([{
                uid: passedUid,
                id: passedId || "---",
                url: `${baseUrl}${passedUid}`
            }]);
            setCount(1);
        }
    }, [location]);

    const handleGenerate = async () => {
        if (!canCreate) return;
        if (count < 1) return;
        setLoading(true);
        try {
            const response = await backEnd_request.post("/Establishments/GenUid?count=" + count);
            const newData = response.data.map(item => ({
                uid: item.fieldUID,
                id: item.establishmentId,
                url: `${baseUrl}${item.fieldUID}`
            }));
            console.log(newData);
            setGeneratedData(newData);
        } catch (err) {
            console.error("Error fetching from API:", err);
            alert("حدث خطأ أثناء الاتصال بالسيرفر");
        } finally {
            setLoading(false);
        }
    };

    const exportPDF = async () => {
        if (!canExportPdf) return;
        if (generatedData.length === 0) return;
        setIsExporting(true);
        await new Promise(r => setTimeout(r, 700));

        const pdf = new jsPDF("p", "mm", "a4");
        const pages = exportRef.current.querySelectorAll(".print-page");

        for (let i = 0; i < pages.length; i++) {
            const canvas = await html2canvas(pages[i], {
                scale: 2,
                useCORS: true,
                logging: false,
                windowWidth: 1200
            });

            const imgData = canvas.toDataURL("image/jpeg", 0.9);
            if (i > 0) pdf.addPage();
            pdf.addImage(imgData, "JPEG", 0, 0, 210, 297);
        }

        pdf.save("Custpro_Cards.pdf");
        setIsExporting(false);
    };

    const OriginalCardDesign = ({ item, showLine }) => (
        <div style={cardStyle}>
            <div style={innerContainer}>
                <div style={rightSide}>
                    <h1 style={titleStyle}>حماية المستهلك وسلامة الغذاء</h1>
                    <p style={descStyle}>ساهم معنا في رفع جودة الخدمة من خلال مسح الرمز ومن ثم :</p>
                    <div style={listStyle}>
                        <div style={listItem}><FaStar color="#f59e0b" size={20} /> <span>تقييم مستوى الخدمة</span></div>
                        <div style={listItem}><FaLightbulb color="#3b82f6" size={20} /> <span>مشاركتنا مقترحاتك</span></div>
                        <div style={listItem}><FaExclamationCircle color="#ef4444" size={20} /> <span>تقديم شكوى مباشرة</span></div>
                    </div>
                    <div className="text-center" style={{ marginTop: '25px', fontSize: '18px', color: '#3112a1ff', fontWeight: 'bold' }}>
                        وفي حال تعذر مسح الرمز يمكنك زيارة الموقع
                        <div className="text-center">https://custpro.org</div>
                    </div>
                </div>

                <div style={leftSide}>
                    {/* مربع الـ QR مع عبارة امسح هنا بداخله */}
                    <div style={qrBox}>
                        <QRCodeCanvas value={item.url} size={180} level={"H"} />
                        {/* <p style={{ marginTop: '12px', fontSize: '14px', fontWeight: 'bold', color: '#333', marginBottom: 0 }}>امسح هنا (SCAN)</p> */}
                    </div>

                    {/* معرف المنشأة تحت المربع وبخط أصغر */}
                    <div style={facilityIdContainer}>
                        رقم المنشأة: <span style={{ fontWeight: '900' }}>{item.id}</span>
                    </div>
                </div>
            </div>
            {showLine && <div style={cutDashedLine}></div>}
        </div>
    );

    return (
        <div className="bg-light min-vh-100 py-4" dir="rtl" style={{ overflowX: 'hidden' }}>
            <div className="container shadow-sm bg-white rounded-4 p-4 d-print-none mb-4">
                <div className="row g-3 align-items-center">
                    <div className="col-12 col-md-6">
                        <h3 className="fw-bold m-0 text-dark">توليد بطاقات المنشآت</h3>
                        <p className="text-muted small mb-0">سحب البيانات من السيرفر وعرض معرف المنشأة</p>
                    </div>
                    <div className="col-12 col-md-6 d-flex gap-2 justify-content-md-end">
                        {canExportPdf && (
                            <button onClick={exportPDF} className="btn btn-danger rounded-pill px-4 shadow-sm" disabled={isExporting || generatedData.length === 0}>
                                {isExporting ? "جاري التصدير..." : "تصدير PDF"}
                            </button>
                        )}
                        <button onClick={() => navigate(-1)} className="btn btn-outline-secondary rounded-pill">رجوع</button>
                    </div>
                </div>
                {canCreate && (
                    <div className="row g-2 mt-3">
                        <div className="col-4">
                            <input type="number" className="form-control rounded-3" value={count} onChange={(e) => setCount(Number(e.target.value))} min="1" />
                        </div>
                        <div className="col-4">
                            <button onClick={handleGenerate} className="btn btn-primary w-100 rounded-3" disabled={loading}>
                                {loading ? "جاري الطلب..." : "توليد من السيرفر"}
                            </button>
                        </div>
                        <div className="col-4">
                            <button onClick={() => setGeneratedData([])} className="btn btn-outline-danger w-100 rounded-3">حذف</button>
                        </div>
                    </div>
                )}
            </div>

            <div className="container px-2 d-print-none">
                <div className="row g-4">
                    {generatedData.map((item, idx) => (
                        <div key={idx} className="col-12 col-xl-6">
                            <div className="preview-wrap">
                                <OriginalCardDesign item={item} showLine={false} />
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div style={{ position: 'fixed', left: '-10000px', top: 0, width: '210mm', pointerEvents: 'none', zIndex: -1 }}>
                <div ref={exportRef}>
                    {Array.from({ length: Math.ceil(generatedData.length / 2) }).map((_, pageIndex) => (
                        <div key={pageIndex} className="print-page" style={pageContainerStyle}>
                            {generatedData.slice(pageIndex * 2, pageIndex * 2 + 2).map((item, idx) => (
                                <OriginalCardDesign key={idx} item={item} showLine={idx === 0} />
                            ))}
                        </div>
                    ))}
                </div>
            </div>

            <style>{`
                .preview-wrap { 
                    background: white; 
                    border-radius: 15px; 
                    transform-origin: top right;
                    zoom: 0.5;
                }
                @media (max-width: 576px) { .preview-wrap { zoom: 0.33; } }
                @media (min-width: 1200px) { .preview-wrap { zoom: 0.7; } }
            `}</style>
        </div>
    );
}

// --- التنسيقات المعدلة ---
const pageContainerStyle = { width: "210mm", height: "297mm", backgroundColor: "#fff", display: "flex", flexDirection: "column", position: "relative", direction: "rtl" };
const cardStyle = { height: "148.5mm", width: "100%", padding: "15mm 10mm", display: "flex", alignItems: "center", justifyContent: "center", position: "relative", boxSizing: "border-box" };
const innerContainer = { width: "100%", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", border: "2px solid #222", borderRadius: "15px", padding: "25px", height: "100%", boxSizing: "border-box" };
const rightSide = { flex: "0 0 65%", textAlign: "right", display: "flex", flexDirection: "column", justifyContent: "center" };
const leftSide = { flex: "0 0 35%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" };
const titleStyle = { fontSize: "38px", fontWeight: "900", color: "#000", margin: "0 0 10px 0", lineHeight: "1.2" };
const descStyle = { fontSize: "20px", color: "#444", lineHeight: "1.4", marginBottom: "25px" };
const listStyle = { display: "flex", flexDirection: "column", gap: "12px" };
const listItem = { display: "flex", alignItems: "center", gap: "10px", fontSize: "20px", fontWeight: "bold", color: "#333" };

const qrBox = {
    padding: "20px",
    backgroundColor: "#fff",
    border: "2px solid #ddd",
    borderRadius: "15px",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
};

const facilityIdContainer = {
    marginTop: "10px",
    fontSize: "17px", // حجم الخط أصغر كما طلبت
    color: "#444",
    backgroundColor: "#f9f9f9",
    padding: "3px 12px",
    borderRadius: "6px",
    border: "1px solid #eee"
};

const cutDashedLine = { position: "absolute", bottom: "0", left: "5%", right: "5%", borderBottom: "1px dashed #bbb" };